import React from "react";



const PrivacyPolicy=()=>{
 React.useEffect(()=>{
  document.body.scrollTop = 0; 
  document.documentElement.scrollTop = 0;
 },[])
 return(<>
        <div className="page-head">
 <h4 className="text-center">Terms & Services</h4>   
 {/* <p className="about-txt w-50">
</p> */}
          </div>
<div className="w-80 m-auto">
    
<p className="mt-5" style={{color:'hsl(0deg 0% 58.43%)',fontSize:'18px'}}>Last Updated on 4<sup>th</sup> August 2023.</p>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="mt-4">Welcome to the Aquabird Mineral Water website. Before you proceed, we kindly ask you to 
review and understand our terms and conditions. By accessing or using our website, you agree to comply with and be
 bound by these terms. If you do not agree with any part of these terms, please refrain from using our website.</p>
<h4 className="sect-head mt-5">
1. Intellectual Property
</h4>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="w-97 m-auto">All content on the Aquabird Mineral Water website,
 including but not limited to text, images, graphics, logos, videos, and audio, is the property of Aquabird Mineral 
 Water or its content suppliers and is protected by copyright and intellectual property laws. You may not reproduce,
  distribute, modify, display, or otherwise use any content from our website without prior written consent.</p>
  <h4 className="sect-head mt-5">
  2. Use of the Website
</h4>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="w-97 m-auto">You agree to use the Aquabird Mineral Water website for lawful
 purposes only and in a manner that does not infringe on the rights of, or restrict or inhibit the use of the website 
 by, any third party. You may not use the website to engage in any harmful or illegal activities.</p>
 <h4 className="sect-head mt-5">
 3. User Accounts
</h4>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="w-97 m-auto">Some areas of the website may require you to create a user 
account. You are responsible for maintaining the confidentiality of your account information and password. You agree 
to notify us immediately of any unauthorized use of your account or any other breach of security.</p>
<h4 className="sect-head mt-5">
4. Privacy
</h4>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="w-97 m-auto">We take your privacy seriously. Our Privacy Policy outlines 
how we collect, use, and protect your personal information. By using our website, you consent to the practices 
described in our Privacy Policy.</p>
<h4 className="sect-head mt-5">
5. Links to Third-Party Websites
</h4>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="w-97 m-auto">Our website may contain links to third-party websites that are
 not owned or controlled by Aquabird Mineral Water. We are not responsible for the content, privacy policies, or 
 practices of any third-party websites. You access such third-party websites at your own risk.</p>
 <h4 className="sect-head mt-5">
 6. Disclaimer of Warranties
</h4>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="w-97 m-auto">The information provided on the Aquabird Mineral Water website
 is for general informational purposes only. We do not warrant the accuracy, completeness, or reliability of any 
 information on the website. Your use of the website is at your own risk.</p>
 <h4 className="sect-head mt-5">
 7. Limitation of Liability
</h4>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="w-97 m-auto">Aquabird Mineral Water and its affiliates shall not be liable 
for any direct, indirect, incidental, special, consequential, or punitive damages, arising out of or related to your 
use of the website or any content therein.</p>
<h4 className="sect-head mt-5">
8. Changes to Terms and Conditions
</h4>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="w-97 m-auto">Aquabird Mineral Water reserves the right to modify or revise
 these terms and conditions at any time. By continuing to use the website after any changes, you agree to be bound by
  the revised terms.</p>
  <h4 className="sect-head mt-5">
  9. Governing Law
</h4>
<p style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}} className="w-97 m-auto">These terms and conditions shall be governed by and construed 
in accordance with the laws of [State of Pakistan]. Any disputes arising out of or in connection with these terms shall
 be subject to the exclusive jurisdiction of the courts of (State of Pakistan).</p>
 <p className="mt-5" style={{color:'hsl(0deg 0% 58.43%)',fontSize:'14px'}}>Thank you for reading our terms and conditions.
  If you have any questions or concerns, please contact us at (mineralwateraqubird@gmail.com).</p>
   </div>

    </>)
}

export default PrivacyPolicy;